import {
  clearDebugEvents,
  getDebugEvents,
  subscribeToDebugEvents,
} from "../debug-store";
import type { DebugEvent } from "../types";
import type { ApiLogEntry, ApiLogListener } from "./api-log-store.types";

export type { ApiLogEntry } from "./api-log-store.types";

const SERVER_SNAPSHOT: ApiLogEntry[] = [];
let sourceSnapshot = getDebugEvents();
let apiSnapshot: ApiLogEntry[] = [];

function statusCode(event: DebugEvent): number | null {
  if (event.status === "started" || event.status === "reconciling") return null;
  if (event.status === "succeeded") return 200;
  if (event.status === "cancelled") return 499;
  return 0;
}

function toEntry(event: DebugEvent): ApiLogEntry {
  return {
    id: String(event.id),
    method: "API",
    url: event.route ?? `${event.feature}/${event.operation}`,
    status: statusCode(event),
    duration: event.durationMs ?? null,
    timestamp: event.occurredAt,
    requestBody: null,
    responseBody: null,
    error: event.errorCode,
  };
}

export function subscribeApiLog(listener: ApiLogListener): () => void {
  return subscribeToDebugEvents(listener);
}

export function getApiLogEntries(): ApiLogEntry[] {
  const currentEvents = getDebugEvents();
  if (currentEvents !== sourceSnapshot) {
    sourceSnapshot = currentEvents;
    apiSnapshot = currentEvents.map(toEntry).reverse().slice(0, 50);
  }
  return apiSnapshot;
}

export function getServerSnapshotApiLog(): ApiLogEntry[] {
  return SERVER_SNAPSHOT;
}

export function clearApiLog(): void {
  clearDebugEvents();
}

export function initApiLogInterceptor(): void {
  // API diagnostics enter through the reviewed apiClient metadata boundary.
}
